export default __webpack_public_path__ + "static/media/teamBgMb.7cd3b62e.png";